'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_ClientAppDocumentMetadata(createdBy, createdAt) {
  this.XR = null;
  this.Fr = null;
  this.XR = createdBy;
  this.Fr = createdAt;
}
export { $c_Lapp_data_ClientAppDocumentMetadata as $c_Lapp_data_ClientAppDocumentMetadata };
$p = $c_Lapp_data_ClientAppDocumentMetadata.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_ClientAppDocumentMetadata;
/** @constructor */
function $h_Lapp_data_ClientAppDocumentMetadata() {
}
export { $h_Lapp_data_ClientAppDocumentMetadata as $h_Lapp_data_ClientAppDocumentMetadata };
$h_Lapp_data_ClientAppDocumentMetadata.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_ClientAppDocumentMetadata)) {
    var x = this.XR;
    var x$2 = x$0.XR;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.Fr;
      var x$4 = x$0.Fr;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "ClientAppDocumentMetadata";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.XR;
  }
  if ((n === 1)) {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDateTime(this.Fr);
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "createdBy";
  }
  if ((n === 1)) {
    return "createdAt";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_ClientAppDocumentMetadata(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jh)));
}
export { $isArrayOf_Lapp_data_ClientAppDocumentMetadata as $isArrayOf_Lapp_data_ClientAppDocumentMetadata };
var $d_Lapp_data_ClientAppDocumentMetadata = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_ClientAppDocumentMetadata, "app.data.ClientAppDocumentMetadata", ({
  jh: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_ClientAppDocumentMetadata as $d_Lapp_data_ClientAppDocumentMetadata };
//# sourceMappingURL=app.data.-Client-App-Document-Metadata.js.map
